import { useHistory, useRouteMatch } from 'react-router-dom';

import { Col, Row } from 'antd';

import BoxContainer from '@src/components/BoxContainer';
import Title from '@src/components/BoxContainer/components/Title';
import ShiftCardOption from '@src/components/Cards/shifts/ShiftCardOption';
import FilterContainer from '@src/components/FilterContainer';
import { PATHS } from '@src/packages/shifts/constants';
import { ALLOWED_ROLES, getFullUrl } from '@src/packages/utils';
import IntlMessages from '@src/util/IntlMessages';

import styles from './styles.module.less';

const SHIFT_TYPE_OPTIONS = [
  {
    id: 'fixed',
    titleId: 'shifts.fixed.title',
    descriptionId: 'shifts.fixed.description',
    actionLabelId: 'shifts.create.typeAction.fixed',
    icon: 'schedule',
    href: PATHS.SHIFT_FIXED,
  },
  {
    id: 'part-time',
    titleId: 'shifts.part.time.title',
    descriptionId: 'shifts.part.time.description',
    actionLabelId: 'shifts.create.typeAction.partTime',
    icon: 'access_time',
    href: PATHS.SHIFT_PART_TIME,
  },
  {
    id: 'shift',
    titleId: 'shifts.work.title',
    descriptionId: 'shifts.work.description',
    actionLabelId: 'shifts.create.typeAction.shift',
    icon: 'rotate_right',
    href: PATHS.SHIFT_WORKDAY,
  },
  {
    id: 'cycle',
    titleId: 'shifts.cycle.title',
    descriptionId: 'shifts.cycle.description',
    actionLabelId: 'shifts.create.typeAction.cycle',
    icon: 'loop',
    href: PATHS.SHIFT_CYCLE,
  },
  {
    id: 'bi-weekly',
    titleId: 'shifts.biweekly.title',
    descriptionId: 'shifts.biweekly.description',
    actionLabelId: 'shifts.create.typeAction.biWeekly',
    icon: 'calendar_view_week',
    href: PATHS.SHIFT_BIWEEKLY,
  },
] as const;

export default function ShiftOptions() {
  const navigate = useHistory();
  const { url } = useRouteMatch();

  return (
    <BoxContainer>
      <BoxContainer content fixed bottomBorder>
        <FilterContainer
          goBack={() => navigate.goBack()}
          title={<Title.Header value={<IntlMessages id="shifts.what.shift.create" />} />}
        />
      </BoxContainer>
      <BoxContainer content>
        <div className={styles.shiftTypesContainer}>
          <p className={styles.typeSelectionHint}>
            <IntlMessages id="shifts.create.typeSelectionHint" />
          </p>
          <Row gutter={[24, 24]}>
            {SHIFT_TYPE_OPTIONS.map(option => (
              <Col key={option.id} xs={24} sm={12} lg={12}>
                <ShiftCardOption
                  icon={option.icon}
                  title={<IntlMessages id={option.titleId} />}
                  description={<IntlMessages id={option.descriptionId} />}
                  actionLabel={<IntlMessages id={option.actionLabelId} />}
                  allowedRoles={ALLOWED_ROLES.ORGANIZATIONS.WORK_SHIFTS.CREATE}
                  onCreate={() => navigate.push(getFullUrl(option.href, url))}
                />
              </Col>
            ))}
          </Row>
        </div>
      </BoxContainer>
    </BoxContainer>
  );
}
